module.exports = __webpack_public_path__ + "img/logoLongWhite.795c2765.png";